import { ORGANISATIONS_STATUSES } from 'constants/organisations';

const statusOrder = {
  [ORGANISATIONS_STATUSES.ACTIVE]: 1,
  [ORGANISATIONS_STATUSES.ARCHIVED]: 2,
};

export const sortOrganisations = (orgList = []) =>
  orgList.toSorted((a, b) => statusOrder[a.status] - statusOrder[b.status] || b.updatedAt - a.updatedAt);
